<!-- <div class="row h-100 d-none">
    <div class="col-lg-6 col-md-12 mx-auto align-self-center">
      <div class="login-form">
        <div class="text-center">
          <h3 class="title">Forgot Password</h3>
        
        </div>
   <form [formGroup]="forgotForm">
          <div class="mb-4">
            <label class="mb-1 text-dark">Enter Email/Mobile No</label>
            <input
              type="text"
                formControlName="UserId"
              [maxLength]="50"
              placeholder="Enter Email/Mobile No"
              class="form-control form-control"
              (keypress)="allowOnlyNumbers($event)"
                [readonly]="isOTPVerified"
                [ngClass]="{'invalid-input': forgotForm.get('UserId')?.errors?.['required'] && isSubmit}"
            />
          </div>
          <div class="mb-4" *ngIf="isOTPverify">
            <label class="mb-1 text-dark">Password</label>
            <input
              type="password"
                formControlName="sPassword"
            
              placeholder="Enter Password"
              class="form-control form-control"
                
                [ngClass]="{'invalid-input': forgotForm.get('sPassword')?.errors?.['required'] && isSubmit}"
            />
            <div *ngIf="forgotForm.get('sPassword')?.touched && forgotForm.get('sPassword')?.invalid" class="text-danger">
                <div *ngIf="forgotForm.get('sPassword')?.errors?.['required']">Password is required.</div>
                <div *ngIf="forgotForm.get('sPassword')?.errors?.['minlength']">Password must be at least 8 characters.</div>
                <div *ngIf="forgotForm.get('sPassword')?.errors?.['pattern']">
                  Password must include at least one number and one special character.
                </div>
              </div>
          </div>
          <div class="mb-4" *ngIf="isOTPverify">
            <label class="mb-1 text-dark">Confirm Password</label>
            <input
              type="password"
                formControlName="confirmPassword"
            
              placeholder="Enter Confirm Password"
              class="form-control form-control"
                
                [ngClass]="{'invalid-input': forgotForm.get('confirmPassword')?.errors?.['required'] && isSubmit}"
            />
            <div class="text-danger" *ngIf="forgotForm.hasError('passwordsMismatch')">
                Passwords do not match.
              </div>
          </div>
          <div class="mb-4" *ngIf="isOTPVerified  && !isOTPverify">
            <label class="mb-1 text-dark">OTP</label>
            <input
              type="text"
             [(ngModel)]="submitOTP"
              placeholder="Enter OTP"
              class="form-control form-control"
              (keypress)="allowOnlyNumbers($event)"
              (change)="StoreOTP($event)"
                          />

          </div>
          <div class="text-center mb-4" *ngIf="!isOTPVerified">
            <button type="submit" (click)="SentOTP()"  class="btn btn-primary btn-block w-40 m-3">
             Send OTP
            </button>
            
            <button type="submit" [routerLink]="['/login']"  class="btn btn-primary btn-block w-40">
                Login
               </button>
           
          </div>
          <div class="text-center mb-4" *ngIf="isOTPVerified  && !isOTPverify">
            <button type="submit"  class="btn btn-primary btn-block w-100" (click)="verifyOTP()">
              Submit
            </button>
          </div>
          <div class="text-center mb-4" *ngIf="isOTPverify">
            <button type="submit"  class="btn btn-primary btn-block w-100" (click)="SubmitData()">
              Submit
            </button>
          </div>
        </form>
      </div>
    
    </div>
    <div class="col-lg-6 col-md-12">
      <div class="pages-left h-100">
        <div class="login-content">
          <a href="javascript:void(0)"
            ><img
              src="../../assets/images/logos/hplogo.png"
              class="mb-3 logo-dark"
              width="80px"
              alt=""
          /></a>
  
          <p>
            Department of Cooperation <br />
            Himachal Pradesh
          </p>
        </div>
        <div class="login-media text-center">
          <img src="../../assets/images/login.png" alt="" />
        </div>
      </div>
    </div>
  </div>
<div class="container-fluid min-vh-100 d-flex align-items-center justify-content-center login-page-bg">
  <div class="row w-100">

    <div class="col-lg-12 col-md-12 d-flex align-items-center justify-content-center mb-2 mb-lg-0 ">
      <div class="branding-box shadow p-3 w-100" style="max-width: 450px;">
        
        <div class="text-center text-white  mb-1">
          <img src="../../assets/images/logos/hplogo.png" alt="HP Logo" width="80" class="mb-3 bg-white p-2 rounded-circle" />
          <h4 class="fw-bold mb-2">Department of Cooperation</h4>
          <p class="mb-0">Government of Himachal Pradesh</p>
          <h3 class="fw-bold">Reset Password</h3>
         
        </div>

        
<form [formGroup]="forgotForm">
          <div class="mb-4">
            <label class="mb-1 ">Enter Email/Mobile No</label>
            <input
              type="text"
                formControlName="UserId"
              [maxLength]="50"
              placeholder="Enter Email/Mobile No"
              class="form-control form-control"
              (keypress)="allowOnlyNumbers($event)"
                [readonly]="isOTPVerified"
                [ngClass]="{'invalid-input': forgotForm.get('UserId')?.errors?.['required'] && isSubmit}"
            />
          </div>
          <div class="mb-4" *ngIf="isOTPverify">
            <label class="mb-1 text-dark">Password</label>
            <input
              type="password"
                formControlName="sPassword"
            
              placeholder="Enter Password"
              class="form-control form-control"
                
                [ngClass]="{'invalid-input': forgotForm.get('sPassword')?.errors?.['required'] && isSubmit}"
            />
            <div *ngIf="forgotForm.get('sPassword')?.touched && forgotForm.get('sPassword')?.invalid" class="text-danger">
                <div *ngIf="forgotForm.get('sPassword')?.errors?.['required']">Password is required.</div>
                <div *ngIf="forgotForm.get('sPassword')?.errors?.['minlength']">Password must be at least 8 characters.</div>
                <div *ngIf="forgotForm.get('sPassword')?.errors?.['pattern']">
                  Password must include at least one number and one special character.
                </div>
              </div>
          </div>
          <div class="mb-4" *ngIf="isOTPverify">
            <label class="mb-1 text-dark">Confirm Password</label>
            <input
              type="password"
                formControlName="confirmPassword"
            
              placeholder="Enter Confirm Password"
              class="form-control form-control"
                
                [ngClass]="{'invalid-input': forgotForm.get('confirmPassword')?.errors?.['required'] && isSubmit}"
            />
            <div class="text-danger" *ngIf="forgotForm.hasError('passwordsMismatch')">
                Passwords do not match.
              </div>
          </div>
          <div class="mb-4" *ngIf="isOTPVerified  && !isOTPverify">
            <label class="mb-1 text-dark">OTP</label>
            <input
              type="text"
             [(ngModel)]="submitOTP"
              placeholder="Enter OTP"
              class="form-control form-control"
              (keypress)="allowOnlyNumbers($event)"
              (change)="StoreOTP($event)"
                          />

          </div>
          <div class="text-center mb-4" *ngIf="!isOTPVerified">
            <button type="submit" (click)="SentOTP()"  class="btn btn-primary btn-block w-40 m-3">
             Send OTP
            </button>
            
            <button type="submit" [routerLink]="['/login']"  class="btn btn-primary btn-block w-40">
                Login
               </button>
           
          </div>
          <div class="text-center mb-4" *ngIf="isOTPVerified  && !isOTPverify">
            <button type="submit"  class="btn btn-primary btn-block w-100" (click)="verifyOTP()">
              Submit
            </button>
          </div>
          <div class="text-center mb-4" *ngIf="isOTPverify">
            <button type="submit"  class="btn btn-primary btn-block w-100" (click)="SubmitData()">
              Submit
            </button>
          </div>
        </form>





      </div>
    </div>

  </div>
</div>

 -->


















 <div
  class="main-container font-sans antialiased text-slate-900 dark:text-slate-100 bg-slate-50 dark:bg-slate-950 transition-colors duration-500 overflow-hidden relative selection:bg-blue-500/30">

  <!-- Background Layers -->
  <div class="fixed inset-0 z-0 bg-slate-50 dark:bg-[#050A14] transition-colors duration-500"></div>

  <!-- Abstract Shapes -->
  <div class="fixed inset-0 z-0 overflow-hidden pointer-events-none">
    <div
      class="absolute -top-[10%] -left-[10%] w-[50vw] h-[50vw] rounded-full bg-blue-600/20 blur-[120px] mix-blend-multiply dark:mix-blend-screen animate-pulse"
      style="animation-duration: 10s"></div>
    <div
      class="absolute top-[20%] right-[10%] w-[30vw] h-[30vw] rounded-full bg-purple-500/20 blur-[100px] mix-blend-multiply dark:mix-blend-screen animate-pulse"
      style="animation-duration: 12s; animation-delay: 1s;"></div>
    <div
      class="absolute -bottom-[10%] left-[20%] w-[40vw] h-[40vw] rounded-full bg-teal-500/20 blur-[100px] mix-blend-multiply dark:mix-blend-screen animate-pulse"
      style="animation-duration: 15s; animation-delay: 2s;"></div>
  </div>

  <div class="fixed inset-0 z-0 texture-overlay"></div>
   <div class="absolute top-0 left-0 w-full z-50 px-6 py-4 flex justify-end items-center">
        <!-- Buttons -->
        <div class="flex items-center gap-3">
          <button (click)="toggleTheme()" class="rounded-full w-10 h-10 flex items-center justify-center 
         bg-white/40 hover:bg-white/60 dark:bg-black/20 dark:hover:bg-black/40 
         backdrop-blur-md border border-white/20 dark:border-white/10 shadow-sm 
         transition-all hover:scale-105 cursor-pointer">
            <i class="bi" [ngClass]="isDark ? 'bi-moon-fill text-yellow-400' : 'bi-lightbulb-fill text-yellow-400'"></i>
          </button>


          <button (click)="toggleLanguage()"
            class="rounded-full px-5 h-10 flex items-center bg-gov-navy text-white hover:bg-blue-900 dark:bg-blue-600 dark:hover:bg-blue-500 shadow-md transition-all hover:scale-105 border border-transparent cursor-pointer">
            <i class="bi bi-globe me-2"></i>
            <span id="lang-text" class="text-xs font-bold tracking-wide">
              {{ !isEnglish ? 'HINDI' : 'ENGLISH' }}
            </span>
          </button>
        </div>
      </div>
  <!-- Main Panels -->
  <div class="z-10 w-full flex items-center justify-center p-4 lg:p-8 relative h-screen">

    <div
      class="w-full max-w-6xl h-full lg:h-[85vh] flex flex-col lg:flex-row overflow-hidden rounded-[2rem] shadow-2xl glass-panel ring-1 ring-black/5 dark:ring-white/5">

      <!-- Left Panel (Hero) -->
      <div class="left-panel relative hidden lg:flex w-1/2 flex-col justify-between p-12 overflow-hidden group">

        <div class="absolute inset-0 z-0 bg-gradient-to-br from-blue-900/90 to-slate-900/90 mix-blend-multiply z-10">
        </div>
        <img src="https://images.unsplash.com/photo-1497366216548-37526070297c?auto=format&fit=crop&q=80&w=1000"
          alt="Background"
          class="absolute inset-0 w-full h-full object-cover opacity-40 scale-105 transition-transform duration-[20s] ease-linear group-hover:scale-110 z-[-1]">

        <div class="relative z-20">
          <!-- <div
            class="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-white/10 backdrop-blur-md border border-white/10 text-blue-100 text-xs font-medium mb-6">
            <span class="w-2 h-2 rounded-full bg-emerald-400 animate-pulse"></span>
            Official Portal
          </div> -->

          <div class="mb-6 flex justify-center">
            <img src="../../assets/images/logos/hplogo.png" alt="HP Logo" class="w-32 h-auto object-contain">
          </div>

          <h1 id="hero-title" class="text-5xl font-bold font-heading text-white leading-[1.15] mb-6 drop-shadow-sm">
            {{ translations.forgetPasswordTitle }}
          </h1>
          <p id="hero-desc" class="text-blue-100/80 text-lg leading-relaxed max-w-md">
            {{ translations.forgetPasswordDesc }}
          </p>
        </div>

        <div class="relative z-20 space-y-6">
          <div class="grid grid-cols-2 gap-4">

          </div>
      <p id="footer-text" class="text-xs text-blue-200/60 font-medium tracking-wide">
  © {{ currentYear }} Government of Himachal Pradesh
</p>

        </div>
      </div>

      <!-- Right Panel (Form) -->
      <div
        class="right-panel w-full lg:w-1/2 bg-white/40 dark:bg-black/20 backdrop-blur-md flex flex-col justify-center p-8 sm:p-12 lg:p-16 relative">

        <div class="max-w-sm mx-auto w-full space-y-8">
          <div class="text-center lg:text-left space-y-2">
            <h2 id="welcome-text" class="text-3xl font-bold text-slate-800 dark:text-white tracking-tight">
            Forget Password
            </h2>
          </div>

           <form [formGroup]="forgotForm">
          <div class="mb-4">
            <label class="mb-1 text-dark">Enter Email/Mobile No</label>
            <input
              type="text"
                formControlName="UserId"
              [maxLength]="50"
              placeholder="Enter Email/Mobile No"
              class="form-control form-control"
              (keypress)="allowOnlyNumbers($event)"
                [readonly]="isOTPVerified"
                [ngClass]="{'invalid-input': forgotForm.get('UserId')?.errors?.['required'] && isSubmit}"
            />
          </div>
          <div class="mb-4" *ngIf="isOTPverify">
            <label class="mb-1 text-dark">Password</label>
            <input
              type="password"
                formControlName="sPassword"
            
              placeholder="Enter Password"
              class="form-control form-control"
                
                [ngClass]="{'invalid-input': forgotForm.get('sPassword')?.errors?.['required'] && isSubmit}"
            />
            <div *ngIf="forgotForm.get('sPassword')?.touched && forgotForm.get('sPassword')?.invalid" class="text-danger">
                <div *ngIf="forgotForm.get('sPassword')?.errors?.['required']">Password is required.</div>
                <div *ngIf="forgotForm.get('sPassword')?.errors?.['minlength']">Password must be at least 8 characters.</div>
                <div *ngIf="forgotForm.get('sPassword')?.errors?.['pattern']">
                  Password must include at least one number and one special character.
                </div>
              </div>
          </div>
          <div class="mb-4" *ngIf="isOTPverify">
            <label class="mb-1 text-dark">Confirm Password</label>
            <input
              type="password"
                formControlName="confirmPassword"
            
              placeholder="Enter Confirm Password"
              class="form-control form-control"
                
                [ngClass]="{'invalid-input': forgotForm.get('confirmPassword')?.errors?.['required'] && isSubmit}"
            />
            <div class="text-danger" *ngIf="forgotForm.hasError('passwordsMismatch')">
                Passwords do not match.
              </div>
          </div>
          <div class="mb-4" *ngIf="isOTPVerified  && !isOTPverify">
            <label class="mb-1 text-dark">OTP</label>
            <input
              type="text"
             [(ngModel)]="submitOTP"
              placeholder="Enter OTP"
              class="form-control form-control"
              (keypress)="allowOnlyNumbers($event)"
              (change)="StoreOTP($event)"
                          />

          </div>
          <div class="text-center mb-4" *ngIf="!isOTPVerified">
            <button type="submit" (click)="SentOTP()"  class="btn btn-primary btn-block w-40 m-3">
             Send OTP
            </button>
            
            <button type="submit" [routerLink]="['/login']"  class="btn btn-primary btn-block w-40">
                Login
               </button>
           
          </div>
          <div class="text-center mb-4" *ngIf="isOTPVerified  && !isOTPverify">
            <button type="submit"  class="btn btn-primary btn-block w-100" (click)="verifyOTP()">
              Submit
            </button>
          </div>
          <div class="text-center mb-4" *ngIf="isOTPverify">
            <button type="submit"  class="btn btn-primary btn-block w-100" (click)="SubmitData()">
              Submit
            </button>
          </div>
        </form>
        </div>

      
      </div>

    </div>
  </div>
</div>
